import { render, staticRenderFns } from "./ProjectShortcutsDesktop.vue?vue&type=template&id=12f4f86d"
import script from "./ProjectShortcutsDesktop.vue?vue&type=script&lang=ts"
export * from "./ProjectShortcutsDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports